import PARTNER_NAMES, { RENTSPREE_PRE_LOGIN } from "constants/partner"

export const isPartner = (partnerName) => {
  return PARTNER_NAMES[partnerName] ? true : false
}
